/* eslint-disable */
import React from 'react';
import { getSvgWidth, getSvgHeight } from './svg-size';

interface OutsideHexSvgProps {
  size: string,
  focused: boolean, 
  hoverEffect: boolean, 
  disabled: boolean, 
  theme: any
}

/** Hexagon svg used to add a border to an inner hexgon svg. */
const OutsideHexSvg = React.forwardRef<SVGSVGElement, OutsideHexSvgProps>((props, ref) => {
  const { size, focused, hoverEffect, disabled, theme } = props;
  return (
    <svg
      ref={ref}
      width={`${getSvgWidth(size) + 5}px`}
      height={`${getSvgHeight(size) + 4}px`}
      viewBox="0 0 51 44"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M39.4057903,1.99430487 L49.8376085,19.9943049 C50.5565321,21.2348005 50.5565321,22.7651995 49.8376085,24.0056951 L39.4057903,42.0056951 C38.690403,43.240089 37.3716951,44 35.944983,44 L15.055017,44 C13.6283049,44 12.309597,43.240089 11.5942097,42.0056951 L1.1623915,24.0056951 C0.443467872,22.7651995 0.443467872,21.2348005 1.1623915,19.9943049 L11.5942097,1.99430487 C12.309597,0.759910997 13.6283049,1.15026117e-15 15.055017,0 L35.944983,0 C37.3716951,-1.02007564e-15 38.690403,0.759910997 39.4057903,1.99430487 Z"
          fill={focused && hoverEffect && !disabled ? theme.focused.border : '#FFFFFF00'}
        />
      </g>
    </svg>
  );
});

OutsideHexSvg.displayName = 'OutsideHexSvg';
export { OutsideHexSvg as default };